(function trackerSearchPagination(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousTrackerSearchPagination = global.NewHomeSource.TrackerSearchPagination;

  /**
   * @constructs NewHomeSource.TrackerSearchPagination
   */
  function TrackerSearchPagination() { }

  /**
   * @public
   * pageSizeSelectionTracker: Tracks the events of the page size option selector.
   * @param {Number} pageSize Page size selected number.
   */
  TrackerSearchPagination.pageSizeSelectionTracker = function pageSizeSelectionTracker(pageSize) {
    const ga4Event = {
      eventType: 'GA4Event',
      eventName: 'pagination_events',
      params: {
        click_target: 'Page Count Select',
        // Ticket-BDXPERF-3351: We should send "per page" for both NHS and CNA
        search_value: `${pageSize} per page`
      }
    };

    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: ga4Event
      }
    }));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  TrackerSearchPagination.noConflict = function noConflict() {
    global.NewHomeSource.TrackerSearchPagination = previousTrackerSearchPagination;
    return TrackerSearchPagination;
  };

  global.NewHomeSource.TrackerSearchPagination = TrackerSearchPagination;
}(window));

define("trackerSearchPagination", function(){});

